"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ViewAddMenu;

var _Popper2 = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Paper2 = _interopRequireDefault(require("@material-ui/core/Paper"));

var _ClickAwayListener2 = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _MenuList2 = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _MenuItem2 = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _ListItem2 = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText2 = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _AddBox2 = _interopRequireDefault(require("@material-ui/icons/AddBox"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _IconView = require("./IconView");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

ViewAddMenu.propTypes = {
  onCreate: _propTypes["default"].string
};

function ViewAddMenu(_ref) {
  var onCreate = _ref.onCreate;
  var classes = (0, _styles["default"])();

  var anchorRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showMore = _React$useState2[0],
      setShowMore = _React$useState2[1];

  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setShowMore(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setShowMore(false);
    }
  }

  var listAvailableTypeView = _IconView.listView.map(function (item) {
    return _objectSpread({
      type: item.name
    }, item);
  });

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ListItem2["default"], {
    button: true,
    ref: anchorRef,
    className: classes.listItemView,
    onClick: function onClick() {
      setShowMore(function (prev) {
        return !prev;
      });
    },
    style: {
      paddingLeft: 8,
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_AddBox2["default"], {
    style: {
      fontSize: 17,
      marginRight: 8,
      color: "#031330"
    }
  }), /*#__PURE__*/_react["default"].createElement(_ListItemText2["default"], null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 600,
      fontSize: 13,
      color: "#031330"
    }
  }, "Add View"))), /*#__PURE__*/_react["default"].createElement(_Popper2["default"], {
    open: showMore,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true,
    modifiers: {
      offset: {
        enabled: true,
        offset: "0, 5"
      }
    },
    placement: "bottom-start",
    style: {
      zIndex: 100
    }
  }, /*#__PURE__*/_react["default"].createElement(_Paper2["default"], {
    style: {
      boxShadow: "0 4px 17px 6px rgb(0 0 0 / 10%)"
    }
  }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener2["default"], {
    onClickAway: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_MenuList2["default"], {
    style: {
      width: 150
    },
    autoFocusItem: showMore,
    id: "menu-list-grow",
    onKeyDown: handleListKeyDown
  }, listAvailableTypeView.map(function (item) {
    var type = item.type,
        ViewIcon = item.value;
    var name = type.replace("View", "");
    return /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
      key: item.type,
      onClick: function onClick() {
        setShowMore(false);
        onCreate(item);
      }
    }, /*#__PURE__*/_react["default"].createElement(ViewIcon, {
      fontSize: "small",
      style: {
        marginRight: "0.5rem"
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: "0.875rem",
        marginLeft: 8
      }
    }, name));
  }))))));
}